// The signed-in user's roles in the active organization, from the list cached at login.
export function activeOrgRoles(orgId) {
  try {
    const orgs = JSON.parse(localStorage.getItem('available_organizations') || '[]');
    const org = (Array.isArray(orgs) ? orgs : []).find((o) => o && o.id === orgId);
    return Array.isArray(org?.roles) ? org.roles : [];
  } catch {
    return [];
  }
}
